import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_anhanger-gear/artifacts/lhj2tq1t_Black%20Logo.png";

export default function Footer() {
  return (
    <footer className="bg-zinc-950 text-zinc-400" data-testid="footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img 
                src={LOGO_URL} 
                alt="Rent Mich AT" 
                className="h-14 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-sm leading-relaxed">
              Ihr lokaler Partner für Anhänger-Vermietung in Urfahr-Umgebung. 
              Einfach, fair und zuverlässig.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm hover:text-orange-500 transition-colors">Startseite</Link></li>
              <li><Link to="/anhaenger" className="text-sm hover:text-orange-500 transition-colors">Anhänger mieten</Link></li>
              <li><Link to="/kontakt" className="text-sm hover:text-orange-500 transition-colors">Kontakt</Link></li>
              <li><Link to="/impressum" className="text-sm hover:text-orange-500 transition-colors">Impressum</Link></li>
              <li><Link to="/datenschutz" className="text-sm hover:text-orange-500 transition-colors">Datenschutz</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-sm">
                <MapPin className="h-4 w-4 text-orange-500 mt-0.5 flex-shrink-0" />
                <span>
                  Wagnerweg 8<br />
                  4202 Sonnberg im Mühlkreis<br />
                  Österreich
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Phone className="h-4 w-4 text-orange-500" />
                <a href="tel:+436764138585" className="hover:text-orange-500 transition-colors">
                  +43 676 4138585
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Mail className="h-4 w-4 text-orange-500" />
                <a href="mailto:info@rentmich.at" className="hover:text-orange-500 transition-colors">
                  info@rentmich.at
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-zinc-800 mt-10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm">
            © {new Date().getFullYear()} Rent Mich AT. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="/impressum" className="hover:text-orange-500 transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-orange-500 transition-colors">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
